const apiconfig = {
  develpoment: {
    apiBaseUrl: 'https://meet-by-travel-755c78816a67.herokuapp.com/mbt/',
  },
  production: {
    apiBaseUrl: 'https://mbt-heroku-docker-d09118db8498.herokuapp.com/mbt/',
  }
};

export default apiconfig;